<template>
  <div class="my-footer has-background-light">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    subtitle: String,
  },
};
</script>

<style scoped>
.my-footer {
  display: flex;
  justify-content: flex-end;
  padding: 1rem;
  border-top: 1px solid black;
  background-color: white;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 100;
}
</style>
